import { ga4Track, userExperience } from '@unisporkal/ga4';

const updateABTestVariation = (testName) => {
  const ga4Event = userExperience({
    test_type: 'ab_test',
    test_variation: testName,
  });
  ga4Track(ga4Event);
};

export default updateABTestVariation;
